import { PartnerFlatDTO } from "../domain/models/dto/PartnersDTO";
import { IPartnersFlat } from "../domain/models/Partners";
import { PartnersFlatModel } from "../models/PartnersFlatModel";
import { FileMapper } from "./FileMapper";
import { SimpleMapper } from "./SimpleMapper";

export class PartnersFlatMapper extends SimpleMapper<
    IPartnersFlat,
    PartnerFlatDTO
> {
    protected toDTOFields: string[] = [
        "id",
        "title",
        "description",
        "isActive",
        "languageCode",
        "files",
        "websiteUrl",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "updatedAt",
        "createdAt",
        "creatorId",
    ];
    protected entityConstructor = PartnersFlatModel;

    private fileMapper = new FileMapper();

    fromDTO(dto: PartnerFlatDTO): IPartnersFlat {
        if (!dto) return null;

        const baseDto = super.fromDTO(dto);
        baseDto.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];
        return baseDto;
    }

    toDTO(model: IPartnersFlat): PartnerFlatDTO {
        if (!model) return null;

        const baseDto = super.toDTO(model);
        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];
        return baseDto;
    }
}
